// 動態載入 src/assets/images 內的圖片
// export function loadImages() {
//     const context = require.context("@/assets/images", false, /\.(png|jpe?g|gif|svg)$/);
//     return context.keys().map((key) => context(key));
//   }

// 根據螢幕寬度載入不同資料夾的圖片
export function loadImages() {
  const isMobile = window.innerWidth <= 700;
  if (isMobile) {
    return [
      require("@/assets/images/mobile/mobile 1_0.jpg"),
      require("@/assets/images/mobile/mobile 2_0.jpg"),
      require("@/assets/images/mobile/mobile 3_0.jpg"),
    ];
  } else {
    return [
      require("@/assets/images/computer/Frame 1_0.jpg"),
      require("@/assets/images/computer/Frame 2_0.jpg"),
      require("@/assets/images/computer/Frame 3_0.jpg"),
    ];
  }
}

  
  // 切換到指定的頁面
  export function goToSlide(index) {
    this.currentSlide = index;
  }
  
  // 切換到下一張圖片
  export function nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.images.length;
  }
  
  // 啟動自動輪播
  export function startAutoSlide() {
    this.autoSlideInterval = setInterval(() => {
      this.nextSlide();
    }, 3500);
  }
  
  // 停止自動輪播
  export function stopAutoSlide() {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = null;
    }
  }
  